var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { TurtleParser } from '../turtle/TurtleParser';
import { Lexer, Parser, } from 'chevrotain';
import { getShaclVisitor } from 'shacl/visitor';
var _a = require('./tokens'), getShaclTokenTypes = _a.getShaclTokenTypes, getShaclTokenMap = _a.getShaclTokenMap, categoryTokenMap = _a.categoryTokenMap;
var turtleTokenMap = require('../turtle/tokens').turtleTokenMap;
// A SHACL parser for the Turtle serialization of SHACL only. The parser can
// can accept any arbitrary namespace prefix for SHACL/XSD and still tokenize
// and parse the document correctly (it will also, of course, parse docuemnts
// using the full SHACL/XSD IRIs). The parser runs both a parse phase and a
// second validation phase (using a visitor) in order to accommodate SHACL
// rules that are not purely syntactic.
var ShaclParser = /** @class */ (function (_super) {
    __extends(ShaclParser, _super);
    function ShaclParser(config, prefixes) {
        if (prefixes === void 0) { prefixes = { shacl: 'sh', xsd: 'xsd' }; }
        var _this = _super.call(this, __assign({ outputCst: true, recoveryEnabled: true }, config), getShaclTokenTypes(prefixes), getShaclTokenTypes(prefixes), false) || this;
        // Some SHACL rules cannot be checked for violations during the first parse.
        // The visitor accepts the CST that results from parsing and checks
        // conformity with these SHACL rules.
        _this.validateWithVisitor = function (cst) {
            // To save resources while parsing, the shaclVisitor is a singleton.
            if (!_this.shaclVisitor) {
                var BaseSrsVisitor = _this.getBaseCstVisitorConstructorWithDefaults();
                _this.shaclVisitor = getShaclVisitor(BaseSrsVisitor);
            }
            else {
                _this.shaclVisitor.$resetState();
            }
            _this.shaclVisitor.visit(cst);
            return _this.shaclVisitor.$validateShapes(_this.prefixes);
        };
        _this.tokenize = function (document) {
            return _this.lexer.tokenize(document).tokens;
        };
        _this.parse = function (document) {
            _this.input = _this.tokenize(document);
            var cst = _this.turtleDoc();
            var validationErrors = _this.validateWithVisitor(cst).validationErrors;
            // Next two items are copied so that they can be returned/held after parse
            // state is cleared.
            var errors = _this.errors.slice();
            var semanticErrors = _this.semanticErrors.concat(validationErrors);
            return {
                errors: errors,
                semanticErrors: semanticErrors,
                cst: cst,
            };
        };
        _this.predicateObjectList = _this.OVERRIDE_RULE('predicateObjectList', function () {
            _this.OR([
                {
                    ALT: function () {
                        _this.SUBRULE(_this.shaclRulePredicateObjectList);
                    },
                },
                {
                    ALT: function () {
                        _this.SUBRULE(_this.verb);
                        _this.SUBRULE(_this.objectList);
                    },
                },
            ]);
            _this.MANY(function () {
                _this.CONSUME(turtleTokenMap.Semicolon);
                _this.OPTION(function () {
                    _this.OR1([
                        {
                            ALT: function () {
                                _this.SUBRULE1(_this.shaclRulePredicateObjectList);
                            },
                        },
                        {
                            ALT: function () {
                                _this.SUBRULE1(_this.verb);
                                _this.SUBRULE1(_this.objectList);
                            },
                        },
                    ]);
                });
            });
        });
        _this.shaclRulePredicateObjectList = _this.RULE('shaclRulePredicateObjectList', function () {
            _this.OR([
                {
                    ALT: function () { return _this.SUBRULE(_this.shaclPredicateIRI); },
                },
                {
                    ALT: function () { return _this.SUBRULE(_this.shaclNodeKind); },
                },
                {
                    ALT: function () { return _this.SUBRULE(_this.shaclTargetNode); },
                },
                {
                    ALT: function () { return _this.SUBRULE(_this.shaclPropertyPath); },
                },
                {
                    ALT: function () { return _this.SUBRULE(_this.shaclLiteralConstraint); },
                },
                {
                    ALT: function () { return _this.SUBRULE(_this.shaclListTakingConstraint); },
                },
                {
                    ALT: function () { return _this.SUBRULE(_this.shaclShapeExpectingConstraint); },
                },
                {
                    ALT: function () { return _this.SUBRULE(_this.shaclHasValueConstraint); },
                },
                {
                    ALT: function () { return _this.SUBRULE(_this.shaclVerbShape); },
                },
            ]);
        });
        _this.shaclPredicateIRI = _this.RULE('shaclPredicateIRI', function () {
            _this.OR([
                {
                    ALT: function () {
                        _this.CONSUME(categoryTokenMap.SingleIriTakingPredicate);
                        _this.SUBRULE(_this.iri);
                    },
                },
                {
                    ALT: function () {
                        _this.CONSUME(categoryTokenMap.ManyIriTakingPredicate);
                        _this.SUBRULE1(_this.iri);
                        _this.MANY(function () {
                            _this.CONSUME(turtleTokenMap.Comma);
                            _this.SUBRULE2(_this.iri);
                        });
                    },
                },
            ]);
        });
        _this.shaclNodeKind = _this.RULE('shaclNodeKind', function () {
            _this.CONSUME(_this.shaclTokenMap.SHACL_nodeKind);
            _this.CONSUME(categoryTokenMap.NodeKindIRI);
        });
        _this.shaclTargetNode = _this.RULE('shaclTargetNode', function () {
            _this.CONSUME(_this.shaclTokenMap.SHACL_targetNode);
            _this.SUBRULE(_this.shaclIRIOrLiteral);
            _this.MANY(function () {
                _this.CONSUME(turtleTokenMap.Comma);
                _this.SUBRULE1(_this.shaclIRIOrLiteral);
            });
        });
        _this.shaclVerbShape = _this.RULE('shaclVerbShape', function () {
            _this.SUBRULE(_this.verb);
            _this.SUBRULE(_this.shaclShapeType);
            _this.MANY(function () {
                _this.CONSUME(turtleTokenMap.Comma);
                _this.SUBRULE1(_this.shaclShapeType);
            });
        });
        _this.shaclShapeType = _this.RULE('shaclShapeType', function () {
            _this.OR([
                {
                    ALT: function () { return _this.CONSUME(_this.shaclTokenMap.SHACL_Shape); },
                },
                {
                    ALT: function () { return _this.CONSUME(_this.shaclTokenMap.SHACL_NodeShape); },
                },
                {
                    ALT: function () { return _this.CONSUME(_this.shaclTokenMap.SHACL_PropertyShape); },
                },
            ]);
        });
        _this.shaclPropertyPath = _this.RULE('shaclPropertyPath', function () {
            _this.CONSUME(_this.shaclTokenMap.SHACL_path);
            _this.SUBRULE(_this.shaclPropertyPathPath);
        });
        _this.shaclPropertyPathPath = _this.RULE('shaclPropertyPathPath', function () {
            _this.OR([
                {
                    ALT: function () { return _this.SUBRULE(_this.shaclPredicatePath); },
                },
                {
                    ALT: function () { return _this.SUBRULE(_this.shaclSequencePath); },
                },
                {
                    ALT: function () { return _this.SUBRULE(_this.shaclAlternativePath); },
                },
                {
                    ALT: function () { return _this.SUBRULE(_this.shaclInversePath); },
                },
                {
                    ALT: function () { return _this.SUBRULE(_this.shaclZeroOrMorePath); },
                },
                {
                    ALT: function () { return _this.SUBRULE(_this.shaclOneOrMorePath); },
                },
                {
                    ALT: function () { return _this.SUBRULE(_this.shaclZeroOrOnePath); },
                },
            ]);
        });
        _this.shaclPredicatePath = _this.RULE('shaclPredicatePath', function () {
            _this.OR([
                {
                    ALT: function () { return _this.SUBRULE(_this.iri); },
                },
                {
                    // This case does not seem to be allowed by the SHACL spec, but the
                    // online W3C validator accepts one level of parens wrapping the IRI.
                    ALT: function () {
                        _this.CONSUME(turtleTokenMap.LParen);
                        _this.SUBRULE1(_this.iri);
                        _this.CONSUME(turtleTokenMap.RParen);
                    },
                },
            ]);
        });
        _this.shaclSequencePath = _this.RULE('shaclSequencePath', function () {
            _this.CONSUME(turtleTokenMap.LParen);
            _this.SUBRULE(_this.shaclPropertyPathPath);
            _this.AT_LEAST_ONE(function () { return _this.SUBRULE1(_this.shaclPropertyPathPath); });
            _this.OPTION(function () { return _this.CONSUME(turtleTokenMap.Semicolon); });
            _this.CONSUME(turtleTokenMap.RParen);
        });
        _this.shaclAlternativePath = _this.RULE('shaclAlternativePath', function () {
            _this.CONSUME(turtleTokenMap.LBracket);
            _this.CONSUME(_this.shaclTokenMap.SHACL_alternativePath);
            _this.SUBRULE(_this.shaclPropertyPathPath); // This does not match the SHACL spec, but it does match the test cases, which violate the spec. ;_;
            _this.OPTION(function () { return _this.CONSUME(turtleTokenMap.Semicolon); });
            _this.CONSUME(turtleTokenMap.RBracket);
        });
        _this.shaclInversePath = _this.RULE('shaclInversePath', function () {
            _this.CONSUME(turtleTokenMap.LBracket);
            _this.CONSUME(_this.shaclTokenMap.SHACL_inversePath);
            _this.SUBRULE(_this.shaclPropertyPathPath);
            _this.OPTION(function () { return _this.CONSUME(turtleTokenMap.Semicolon); });
            _this.CONSUME(turtleTokenMap.RBracket);
        });
        _this.shaclZeroOrMorePath = _this.RULE('shaclZeroOrMorePath', function () {
            _this.CONSUME(turtleTokenMap.LBracket);
            _this.CONSUME(_this.shaclTokenMap.SHACL_zeroOrMorePath);
            _this.SUBRULE(_this.shaclPropertyPathPath);
            _this.OPTION(function () { return _this.CONSUME(turtleTokenMap.Semicolon); });
            _this.CONSUME(turtleTokenMap.RBracket);
        });
        _this.shaclOneOrMorePath = _this.RULE('shaclOneOrMorePath', function () {
            _this.CONSUME(turtleTokenMap.LBracket);
            _this.CONSUME(_this.shaclTokenMap.SHACL_oneOrMorePath);
            _this.SUBRULE(_this.shaclPropertyPathPath);
            _this.OPTION(function () { return _this.CONSUME(turtleTokenMap.Semicolon); });
            _this.CONSUME(turtleTokenMap.RBracket);
        });
        _this.shaclZeroOrOnePath = _this.RULE('shaclZeroOrOnePath', function () {
            _this.CONSUME(turtleTokenMap.LBracket);
            _this.CONSUME(_this.shaclTokenMap.SHACL_zeroOrOnePath);
            _this.SUBRULE(_this.shaclPropertyPathPath);
            _this.OPTION(function () { return _this.CONSUME(turtleTokenMap.Semicolon); });
            _this.CONSUME(turtleTokenMap.RBracket);
        });
        _this.shaclLiteralConstraint = _this.RULE('shaclLiteralConstraint', function () {
            _this.OR([
                {
                    ALT: function () { return _this.SUBRULE(_this.shaclIntConstraint); },
                },
                // TODO: Some specificity here is possibly unnecessary -- e.g., maybe `shaclStringConstraint` and `shaclStringLiteralQuoteConstraint` can be consolidated in some way?
                {
                    ALT: function () { return _this.SUBRULE(_this.shaclStringConstraint); },
                },
                {
                    ALT: function () { return _this.SUBRULE(_this.shaclStringLiteralQuoteConstraint); },
                },
                {
                    ALT: function () { return _this.SUBRULE(_this.shaclLangStringConstraint); },
                },
                {
                    ALT: function () { return _this.SUBRULE(_this.shaclBooleanConstraint); },
                },
                {
                    ALT: function () { return _this.SUBRULE(_this.shaclAnyLiteralConstraint); },
                },
            ]);
        });
        _this.shaclIntConstraint = _this.RULE('shaclIntConstraint', function () {
            _this.CONSUME(categoryTokenMap.IntTakingPredicate);
            _this.OR([
                {
                    ALT: function () { return _this.CONSUME(turtleTokenMap.INTEGER); },
                },
                {
                    ALT: function () { return _this.SUBRULE(_this.shaclXsdInteger); },
                },
            ]);
        });
        _this.shaclStringConstraint = _this.RULE('shaclStringConstraint', function () {
            _this.OR([
                {
                    ALT: function () { return _this.CONSUME(_this.shaclTokenMap.SHACL_select); },
                },
                {
                    ALT: function () { return _this.CONSUME(_this.shaclTokenMap.SHACL_ask); },
                },
            ]);
            _this.SUBRULE(_this.String); // TODO: a bit too lax?
        });
        _this.shaclStringLiteralQuoteConstraint = _this.RULE('shaclStringLiteralQuoteConstraint', function () {
            _this.CONSUME(categoryTokenMap.StringLiteralQuoteTakingPredicate);
            _this.CONSUME(turtleTokenMap.STRING_LITERAL_QUOTE);
            _this.OPTION(function () {
                _this.OR([
                    {
                        ALT: function () { return _this.CONSUME(turtleTokenMap.LANGTAG); },
                    },
                    {
                        ALT: function () {
                            _this.CONSUME(turtleTokenMap.DoubleCaret);
                            _this.CONSUME(_this.shaclTokenMap.SHACL_xsd_string);
                        },
                    },
                    {
                        ALT: function () {
                            _this.CONSUME1(turtleTokenMap.DoubleCaret);
                            _this.CONSUME(_this.shaclTokenMap.SHACL_xsd_anyURI);
                        },
                    },
                ]);
            });
        });
        _this.shaclLangStringConstraint = _this.RULE('shaclLangStringConstraint', function () {
            _this.CONSUME(categoryTokenMap.LangStringTakingPredicate);
            _this.SUBRULE(_this.String);
            _this.OPTION(function () {
                _this.OR([
                    {
                        ALT: function () { return _this.CONSUME(turtleTokenMap.LANGTAG); },
                    },
                    {
                        ALT: function () {
                            _this.CONSUME(turtleTokenMap.DoubleCaret);
                            _this.CONSUME(_this.shaclTokenMap.SHACL_xsd_string);
                        },
                    },
                ]);
            });
        });
        _this.shaclBooleanConstraint = _this.RULE('shaclBooleanConstraint', function () {
            _this.CONSUME(categoryTokenMap.BooleanTakingPredicate);
            _this.OR([
                {
                    ALT: function () { return _this.CONSUME(turtleTokenMap.TRUE); },
                },
                {
                    ALT: function () { return _this.CONSUME(turtleTokenMap.FALSE); },
                },
                {
                    ALT: function () { return _this.SUBRULE(_this.shaclXsdBoolean); },
                },
            ]);
        });
        _this.shaclAnyLiteralConstraint = _this.RULE('shaclAnyLiteralConstraint', function () {
            _this.CONSUME(categoryTokenMap.AnyLiteralTakingPredicate);
            _this.SUBRULE(_this.literal);
        });
        _this.shaclListTakingConstraint = _this.RULE('shaclListTakingConstraint', function () {
            _this.OR([
                {
                    ALT: function () { return _this.SUBRULE(_this.shaclLanguageInConstraint); },
                },
                {
                    ALT: function () { return _this.SUBRULE(_this.shaclShapeListTakingConstraint); },
                },
                {
                    ALT: function () { return _this.SUBRULE(_this.shaclIRIListTakingConstraint); },
                },
                {
                    ALT: function () { return _this.SUBRULE(_this.shaclShapeOrLiteralListTakingConstraint); },
                },
            ]);
        });
        _this.shaclLanguageInConstraint = _this.RULE('shaclLanguageInConstraint', function () {
            _this.CONSUME(_this.shaclTokenMap.SHACL_languageIn);
            _this.SUBRULE(_this.shaclStringCollection);
        });
        _this.shaclStringCollection = _this.RULE('shaclStringCollection', function () {
            _this.CONSUME(turtleTokenMap.LParen);
            _this.MANY(function () {
                _this.CONSUME(turtleTokenMap.STRING_LITERAL_QUOTE);
            });
            _this.CONSUME(turtleTokenMap.RParen);
        });
        _this.shaclShapeListTakingConstraint = _this.RULE('shaclShapeListTakingConstraint', function () {
            _this.OR([
                {
                    ALT: function () { return _this.CONSUME(_this.shaclTokenMap.SHACL_and); },
                },
                {
                    ALT: function () { return _this.CONSUME(_this.shaclTokenMap.SHACL_or); },
                },
                {
                    ALT: function () { return _this.CONSUME(_this.shaclTokenMap.SHACL_xone); },
                },
            ]);
            _this.SUBRULE(_this.shaclShapeCollection);
        });
        _this.shaclShapeCollection = _this.RULE('shaclShapeCollection', function () {
            _this.CONSUME(turtleTokenMap.LParen);
            _this.MANY(function () {
                _this.SUBRULE(_this.shaclShape);
            });
            _this.CONSUME(turtleTokenMap.RParen);
        });
        _this.shaclIRIListTakingConstraint = _this.RULE('shaclIRIListTakingConstraint', function () {
            _this.CONSUME(_this.shaclTokenMap.SHACL_ignoredProperties);
            _this.SUBRULE(_this.shaclIRICollection);
        });
        _this.shaclIRICollection = _this.RULE('shaclIRICollection', function () {
            _this.CONSUME(turtleTokenMap.LParen);
            _this.MANY(function () {
                _this.SUBRULE(_this.iri);
            });
            _this.CONSUME(turtleTokenMap.RParen);
        });
        _this.shaclShapeOrLiteralListTakingConstraint = _this.RULE('shaclShapeOrLiteralListTakingConstraint', function () {
            _this.CONSUME(_this.shaclTokenMap.SHACL_in);
            _this.SUBRULE(_this.shaclShapeOrLiteralCollection);
        });
        _this.shaclShapeOrLiteralCollection = _this.RULE('shaclShapeOrLiteralCollection', function () {
            _this.CONSUME(turtleTokenMap.LParen);
            _this.MANY(function () {
                _this.SUBRULE(_this.shaclShapeOrLiteral);
            });
            _this.CONSUME(turtleTokenMap.RParen);
        });
        _this.shaclShapeExpectingConstraint = _this.RULE('shaclShapeExpectingConstraint', function () {
            _this.CONSUME(categoryTokenMap.ShapeExpectingPredicate);
            _this.SUBRULE(_this.shaclShape);
        });
        _this.shaclHasValueConstraint = _this.RULE('shaclHasValueConstraint', function () {
            _this.CONSUME(_this.shaclTokenMap.SHACL_hasValue);
            _this.SUBRULE(_this.shaclShapeOrLiteral);
        });
        _this.shaclShape = _this.RULE('shaclShape', function () {
            _this.OR([
                {
                    ALT: function () { return _this.SUBRULE(_this.iri); },
                },
                {
                    ALT: function () { return _this.SUBRULE(_this.blankNodePropertyList); },
                },
                {
                    ALT: function () { return _this.SUBRULE(_this.BlankNode); },
                },
            ]);
        });
        _this.shaclShapeOrLiteral = _this.RULE('shaclShapeOrLiteral', function () {
            _this.OR([
                {
                    ALT: function () { return _this.SUBRULE(_this.shaclShape); },
                },
                {
                    ALT: function () { return _this.SUBRULE(_this.literal); },
                },
            ]);
        });
        _this.shaclIRIOrLiteral = _this.RULE('shaclIRIOrLiteral', function () {
            _this.OR([
                {
                    ALT: function () { return _this.SUBRULE(_this.iri); },
                },
                {
                    ALT: function () { return _this.SUBRULE(_this.literal); },
                },
            ]);
        });
        _this.shaclXsdBoolean = _this.RULE('shaclXsdBoolean', function () {
            _this.SUBRULE(_this.shaclStringWithDoubleCaret);
            _this.CONSUME(_this.shaclTokenMap.SHACL_xsd_boolean);
        });
        _this.shaclXsdString = _this.RULE('shaclXsdString', function () {
            _this.SUBRULE(_this.shaclStringWithDoubleCaret);
            _this.CONSUME(_this.shaclTokenMap.SHACL_xsd_string);
        });
        _this.shaclXsdInteger = _this.RULE('shaclXsdInteger', function () {
            _this.SUBRULE(_this.shaclStringWithDoubleCaret);
            _this.CONSUME(_this.shaclTokenMap.SHACL_xsd_integer);
        });
        _this.shaclXsdDate = _this.RULE('shaclXsdDate', function () {
            _this.SUBRULE(_this.shaclStringWithDoubleCaret);
            _this.CONSUME(_this.shaclTokenMap.SHACL_xsd_date);
        });
        _this.shaclXsdAnyURI = _this.RULE('shaclXsdAnyURI', function () {
            _this.SUBRULE(_this.shaclStringWithDoubleCaret);
            _this.CONSUME(_this.shaclTokenMap.SHACL_xsd_anyURI);
        });
        _this.shaclStringWithDoubleCaret = _this.RULE('shaclStringWithDoubleCaret', function () {
            _this.SUBRULE(_this.String);
            _this.CONSUME(turtleTokenMap.DoubleCaret);
        });
        _this.prefixes = prefixes;
        _this.lexer = new Lexer(getShaclTokenTypes(prefixes));
        _this.shaclTokenMap = getShaclTokenMap(prefixes);
        Parser.performSelfAnalysis(_this);
        return _this;
    }
    return ShaclParser;
}(TurtleParser));
export { ShaclParser };
